/**
 * Локали вкладок «Задачи» (DEV-511), «Сделки» (DEV-512) и редактора модели
 * вознаграждения (DEV-513) карточки агента. Модульный словарь — подмешивается в
 * agentsRegistry.* поверх базовых локалей (см. locales/index.ts), чтобы не править
 * монолитные ru/en/vn.ts.
 */

const ru = {
  agentsRegistry: {
    tasks: {
      addTitle: 'Новая задача',
      title: 'Название',
      due: 'Срок',
      assignee: 'Ответственный',
      priority: 'Приоритет',
      description: 'Описание',
      status: 'Статус',
      complete: 'Выполнить',
      reopen: 'Вернуть',
      empty: 'Задач пока нет',
      created: 'Задача создана',
      createError: 'Не удалось создать задачу',
      updateError: 'Не удалось обновить задачу',
      loadError: 'Не удалось загрузить задачи',
      kind: 'Тип',
      kinds: {
        plain: 'Задача',
        meeting: 'Встреча',
        follow_up: 'Повторный контакт',
      },
      statusValues: { open: 'В работе', done: 'Выполнена' },
      priorityValues: { low: 'Низкий', medium: 'Средний', high: 'Высокий' },
    },
    deals: {
      amount: 'Сумма',
      empty: 'Сделок пока нет',
    },
    reward: {
      edit: 'Изменить',
      editTitle: 'Модель вознаграждения',
      model: 'Модель',
      percent: 'Процент вознаграждения',
      specialDesc: 'Описание спецусловий',
      validFrom: 'Действует с',
      validTo: 'Действует по',
      save: 'Сохранить',
      saved: 'Модель вознаграждения обновлена',
      saveError: 'Не удалось сохранить модель вознаграждения',
    },
  },
}

const en = {
  agentsRegistry: {
    tasks: {
      addTitle: 'New task',
      title: 'Title',
      due: 'Due date',
      assignee: 'Assignee',
      priority: 'Priority',
      description: 'Description',
      status: 'Status',
      complete: 'Complete',
      reopen: 'Reopen',
      empty: 'No tasks yet',
      created: 'Task created',
      createError: 'Failed to create task',
      updateError: 'Failed to update task',
      loadError: 'Failed to load tasks',
      kind: 'Type',
      kinds: {
        plain: 'Task',
        meeting: 'Meeting',
        follow_up: 'Follow-up',
      },
      statusValues: { open: 'Open', done: 'Done' },
      priorityValues: { low: 'Low', medium: 'Medium', high: 'High' },
    },
    deals: {
      amount: 'Amount',
      empty: 'No deals yet',
    },
    reward: {
      edit: 'Edit',
      editTitle: 'Reward model',
      model: 'Model',
      percent: 'Reward percent',
      specialDesc: 'Special terms description',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      save: 'Save',
      saved: 'Reward model updated',
      saveError: 'Failed to save reward model',
    },
  },
}

const vn = {
  agentsRegistry: {
    tasks: {
      addTitle: 'Nhiệm vụ mới',
      title: 'Tiêu đề',
      due: 'Hạn',
      assignee: 'Người phụ trách',
      priority: 'Ưu tiên',
      description: 'Mô tả',
      status: 'Trạng thái',
      complete: 'Hoàn thành',
      reopen: 'Mở lại',
      empty: 'Chưa có nhiệm vụ',
      created: 'Đã tạo nhiệm vụ',
      createError: 'Không tạo được nhiệm vụ',
      updateError: 'Không cập nhật được nhiệm vụ',
      loadError: 'Không tải được nhiệm vụ',
      kind: 'Loại',
      kinds: {
        plain: 'Công việc',
        meeting: 'Cuộc gặp',
        follow_up: 'Liên hệ lại',
      },
      statusValues: { open: 'Đang mở', done: 'Hoàn thành' },
      priorityValues: { low: 'Thấp', medium: 'Trung bình', high: 'Cao' },
    },
    deals: {
      amount: 'Số tiền',
      empty: 'Chưa có giao dịch',
    },
    reward: {
      edit: 'Chỉnh sửa',
      editTitle: 'Mô hình thưởng',
      model: 'Mô hình',
      percent: 'Phần trăm thưởng',
      specialDesc: 'Mô tả điều khoản đặc biệt',
      validFrom: 'Hiệu lực từ',
      validTo: 'Hiệu lực đến',
      save: 'Lưu',
      saved: 'Đã cập nhật mô hình thưởng',
      saveError: 'Không lưu được mô hình thưởng',
    },
  },
}

export const agentTasksMessages = { ru, en, vn }
